import createCrudModule from 'vuex-crud';

export default createCrudModule({
  resource: 'offerApply',
  urlRoot: '/offerApply/myOffers',
  parseList(response) {
    const { data } = response;
    var offer = Object.assign({}, response, {
      data: data.data,
      meta: data
    });

    // delete offer.meta.data; //Dont put Data again in meta

    return offer;
  }
});